export class AlbumTrack {
  number: number;
  title: string;
  length: string;
}
